import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { subscribeSse } from '@getpay93/api';
import { api, tokenStore } from '../lib/api';
import { API_BASE_URL } from '../lib/env';
import { qk } from '../data/queryKeys';

export function useUnreadCount(): number {
  const q = useQuery({ queryKey: qk.unreadCount, queryFn: () => api.notifications.unreadCount() });
  return q.data ?? 0;
}

/** Suscribe al stream SSE; cada evento invalida el contador + la lista. */
export function useNotificationsStream(): void {
  const qc = useQueryClient();
  useEffect(() => {
    const token = tokenStore.get();
    if (!token) return;
    const handle = subscribeSse({
      url: `${API_BASE_URL.replace(/\/+$/, '')}${api.notifications.streamPath}`,
      token,
      onMessage: () => {
        qc.invalidateQueries({ queryKey: qk.unreadCount });
        qc.invalidateQueries({ queryKey: qk.notifications });
      },
      onError: () => {},
    });
    return () => handle.close();
  }, [qc]);
}
